/**
 * Top-bar pieces that are built but ship hidden (spec section 6). Each is one flag, off, read by Topbar:
 * the gate is there, not inside the components, so each component still renders in its own spec.
 *
 * Module constants on purpose, not state or settings: nothing turns them on at run time yet (no setting,
 * no data), and a constant cannot be flipped by a test that turns every `useState(false)` into `true`.
 */

/** The Smorgas apps switcher (spec 6a). Off until more Smorgas apps are integrated and available. */
export const appsMenuEnabled = false;

/** The notifications bell and its badge (spec 6b). Off until the notifications feature ships. */
export const notificationsEnabled = false;
